import { createAction, props } from '@ngrx/store'
import { CalendarEventAPIModel, PaginatedAPI } from 'src/app/models/api.model'

const actionPrefix = '[dashboard]'

export const load_calendar_summary_action = createAction(
  `${actionPrefix} load_calendar_summary_action`,
  props<{
    queryParams: {
      key: string
      value: string
    }[]
    searchRequestBody: any
  }>()
)

export const load_calendar_summary_success_action = createAction(
  `${actionPrefix} load_calendar_summary_success_action`,
  props<{ calendar: PaginatedAPI<CalendarEventAPIModel> }>()
)

export const save_calendar_action = createAction(
  `${actionPrefix} save_calendar_action`,
  props<{ calendar: CalendarEventAPIModel; files: File[]; routeTo: string }>()
)

export const save_calendar_success_action = createAction(
  `${actionPrefix} save_calendar_success_action`,
  props<{ calendar: CalendarEventAPIModel }>()
)

export const update_calendar_action = createAction(
  `${actionPrefix} update_calendar_action`,
  props<{ id: CalendarEventAPIModel; calendar: CalendarEventAPIModel; files: File[]; routeTo: string }>()
)

export const update_calendar_success_action = createAction(
  `${actionPrefix} update_calendar_success_action`,
  props<{ calendar: CalendarEventAPIModel }>()
)
export const fetch_calendar_details = createAction(
  `${actionPrefix} fetch_calendar_details`,
  props<{ id: CalendarEventAPIModel }>()
)

export const fetch_calendar_details_success = createAction(
  `${actionPrefix} fetch_calendar_details_success`,
  props<{ calendar: CalendarEventAPIModel }>()
)
